





import Vue from 'vue'

import Localized from '@/components/Localized.tsx'
import { checkCondition } from '@/utils'

export default Vue.extend({
  components: { Localized },
  computed: {
    isSkipped(): boolean {
      return checkCondition(this.skipped, this.value)
    },
    addedClasses(): string[] {
      if (this.css && this.css.addClasses) {
        return this.css.addClasses
      } else {
        return []
      }
    },
    computedLocale(): string {
      return this.locale || this.$i18n.locale
    },
  },
  created() {
    this.$emit('ready')
  },
  props: {
    prompt: {
      required: true,
      type: [String, Object],
    },
    skipped: {
      default: false,
      type: [Boolean, Object],
    },
    value: {
      type: Object,
    },
    css: {
      type: Object,
    },
    locale: {
      type: String,
    },
  },
})
